import { z } from "zod";

// Define the schema for LandingPageConfig
// This will match with golan backend
export const StdLanderPageConfigSchema = z.object({
  lander_description: z.string(),
  img_url: z.string(),
  // Added a default as it used to be hard coded to "Get Started" and we have lots of checkup UI configs in the DB that
  // don't set it explicitly.
  button_text: z.string().default("Get Started")
});

// Define the schema for VideoLandingPageConfig
export const StdVideoLanderPageConfigSchema = z.object({
  lander_description: z.string(),
  mux_playback_id: z.string(),
  auto_play: z.boolean(),
  button_text: z.string().default("Get Started")
});

// Define the schema for VideoCapturePageConfig
export const StdVideoCapturePageConfigSchema = z.object({});

// Define the schema for SurveyPageConfig
// TODO: add more field types like questions, answer_type, etc.
export const StdSurveyPageConfigSchema = z.object({});

// Define the schema for InstructionPageConfig
export const StdInstructionPageConfigSchema = z.object({
  video_playback_id: z.string().optional(),
  video_poster_seconds: z.number().optional(),
  instructions: z.string().optional(),
  tos: z.string().optional(),
  img_url: z.string().optional(),
}).refine(
  (data) => {
    const hasVideoId = !!data.video_playback_id;
    const hasPosterSeconds = data.video_poster_seconds !== undefined;
    return hasVideoId === hasPosterSeconds;
  },
  {
    message: "video_playback_id and video_poster_seconds must be defined together",
    path: ["video_playback_id", "video_poster_seconds"]
  }
).refine(
  (data) => {
    const hasVideo = !!data.video_playback_id;
    const hasImage = !!data.img_url;
    return (hasVideo || hasImage) && hasVideo !== hasImage; },
  {
    message: "Only one of video_playback_id or img_url must be provided.",
    path: ["video_playback_id", "img_url"]
  }
);

// Define the discriminated union schema for PageDefinition
// Will do the enums later for std_lander etc.
export const PageDefinitionSchema = z.discriminatedUnion("kind", [
  z.object({
    kind: z.literal("std_lander"),
    config: StdLanderPageConfigSchema
  }),
  z.object({
    kind: z.literal("std_video_lander"),
    config: StdVideoLanderPageConfigSchema
  }),
  z.object({
    kind: z.literal("std_instructions"),
    config: StdInstructionPageConfigSchema
  }),
  z.object({
    kind: z.literal("std_video_capture"),
    config: StdVideoCapturePageConfigSchema
  }),
  z.object({
    kind: z.literal("std_survey"),
    config: StdSurveyPageConfigSchema
  }),
  // Add other page types here as needed
  // z.object({
  //   kind: z.literal("other_page"),
  //   config: OtherPageConfigSchema
  // })
]);

// Type inference from the schema

export type ValidatedPageDefinition = z.infer<typeof PageDefinitionSchema>; 
export type ValidatedSurveyPageDefinition = z.infer<typeof StdSurveyPageConfigSchema>;
export type ValidatedLandingPageDefinition = z.infer<typeof StdLanderPageConfigSchema>;
export type ValidatedVideoLandingPageDefinition = z.infer<typeof StdVideoLanderPageConfigSchema>;
export type ValidatedInstructionPageDefinition = z.infer<typeof StdInstructionPageConfigSchema>;
export type ValidatedVideoCapturePageDefinition = z.infer<typeof StdVideoCapturePageConfigSchema>;
